// extracted by mini-css-extract-plugin
export default {"wrapper":"text-field_wrapper__l3UL4","label":"text-field_label__BZ+ze","input":"text-field_input__vGtF4"};